import { useQuery } from '@tanstack/react-query';
import { externalUserDashboardApi } from '../api/externalUserDashboardApi';

/**
 * Le garant de la société a-t-il un programme upsell à afficher ?
 *
 * `societyId` ne sert qu'à cloisonner le cache : la réponse dépend de la société
 * de l'utilisateur connecté, l'API la déduit du jeton.
 */
export const useUpsellDashboardAvailability = (societyId: string | undefined, enabled: boolean) => {
  return useQuery({
    queryKey: ['upsell-dashboard-availability', societyId],
    queryFn: externalUserDashboardApi.getUpsellAvailability,
    enabled: enabled && !!societyId,
    staleTime: 10 * 60 * 1000,
    // Onglet facultatif : un échec le masque simplement, inutile d'insister
    retry: false,
  });
};

/**
 * Chiffres du programme upsell du garant sur la période (montants en centimes).
 */
export const useUpsellDashboard = (
  societyId: string | undefined,
  period: { from?: string; to?: string },
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['upsell-dashboard', societyId, period.from, period.to],
    queryFn: () => externalUserDashboardApi.getUpsellDashboard(period),
    enabled: enabled && !!societyId,
    staleTime: 5 * 60 * 1000,
    // Garde les chiffres de la période précédente pendant le rechargement
    // (évite que la page repasse en spinner à chaque changement de filtre)
    keepPreviousData: true,
  });
};
